module.exports = __webpack_public_path__ + "static/media/irregular2.b268384c.jpg";